export interface SavedMapCenter {
  lat: number;
  lng: number;
  zoom: number;
}

function parseCenter(raw: string | null): SavedMapCenter | null {
  if (!raw) return null;
  try {
    const { lat, lng, zoom } = JSON.parse(raw);
    return [lat, lng, zoom].every(Number.isFinite) ? { lat, lng, zoom } : null;
  } catch {
    return null;
  }
}

// Mapbox stores that view as e.g. lat 2.8e-14 rather than exactly 0.
function isUntouchedWorldView({ lat, lng }: SavedMapCenter): boolean {
  return Math.abs(lat) < 1e-6 && Math.abs(lng) < 1e-6;
}

/**
 * Where Find a hike opens when the URL gives no location. The main map and the planner share
 * `currentCenter`, so it comes first; Find a hike's own older `exploreCenter` is the fallback.
 * A `currentCenter` still on (0, 0) is ignored: the planner writes its untouched world view
 * there, and opening on that would replace the IP-based location a first-time visitor gets.
 */
export function resolveExploreSavedCenter(currentCenter: string | null, exploreCenter: string | null): SavedMapCenter | null {
  const shared = parseCenter(currentCenter);
  if (shared && !isUntouchedWorldView(shared)) return shared;
  return parseCenter(exploreCenter);
}
